import React, { useState, useEffect } from 'react';
// const endpoint="http://localhost:3000"
const api = "https://cyrene-api.herokuapp.com"

export default function PrayerRequestIndex(props) {
  const [requests, setRequests] = useState([])
  const getData = async() =>{
    try {
    const response = await fetch(`${api}/prayerrequests`, {
      method: "GET",
      mode:"cors",
      headers: {
        "Content-Type": "application/json"
      }
    })
    const requestData = await response.json()
    setRequests(requestData)
       console.log(requestData)
  } catch (error) {
    console.error(error)
  }
  }
  useEffect(()=>{
    getData()
  },[])
  return(
    <div>
      <h1>Prayer Requests </h1>
      <div className="cardHolder">
          {requests.map(prayer =>{
            return(
              <div className="prayerCard">
                <ul key={prayer.id}>
                  <li key={prayer.id}>Please pray for <h2>{prayer.name}</h2></li>
                  <li>who struggles with {prayer.temptation}</li>
                </ul> 
              </div>
            )
          })
        }
      </div>
    </div>
  )
}